// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/corner-down-right.js';

import { paths } from '../generated/corner-down-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('corner-down-right', Original, paths);
